<dt-modal-content (closeClick)="close()" size="small">
  <ng-template #title i18n>Account löschen</ng-template>
  <ng-template #content>
    @if (userData$ | async; as userData) {
      <p i18n
        >Du bist im Begriff, Deinen Entscheidungsnavi Account zur E-Mail-Adresse
        <span class="highlight">„{{ email$ | async }}“</span> unwiederbringlich zu löschen. Dadurch werden alle
        <span class="highlight">{{ userData.projectCount }} Projekte</span> im Account gelöscht.</p
      >
      @if (userData.submittedEvents.length > 0) {
        <p i18n
          >Deine <span class="highlight">{{ userData.submittedEvents.length }} Veranstaltungsabgaben</span> sind davon nicht betroffen und
          werden nicht gelöscht. Bitte wende Dich direkt an die Verwalter folgender Veranstaltungen, wenn Du Deine Abgaben löschen möchtest:
          {{ userData.submittedEvents.join(', ') }}.</p
        >
      }
      @if (userData.teamsWhereOwner.length > 0) {
        <div>
          <p i18n
            >Du fungierst in folgenden <span class="highlight">{{ userData.teamsWhereOwner.length }} Teams</span> als Moderator:</p
          >
          <ul class="team-list">
            @for (teamName of userData.teamsWhereOwner; track teamName) {
              <li>
                {{ teamName }}
              </li>
            }
          </ul>
          <p i18n class="team-warning highlight"
            >Bevor du deinen Account löschen kannst, musst du das Moderator-Recht an andere Teammitglieder weitergeben oder die Teamprojekte
            löschen.</p
          >
        </div>
      }
      @if (userData.teamsWhereOwner.length === 0) {
        <p i18n>Bitte gib zur Bestätigung Dein Passwort ein.</p>
        <form [formGroup]="confirmForm" (ngSubmit)="delete()">
          <mat-form-field>
            <mat-label i18n>Passwort</mat-label>
            <input matInput type="password" formControlName="password" />
            @if (confirmForm.controls.password.errors?.required) {
              <mat-error i18n>Bitte gib Dein Passwort ein</mat-error>
            }
            @if (confirmForm.controls.password.errors?.wrongPassword) {
              <mat-error i18n>Das Passwort ist falsch</mat-error>
            }
            @if (confirmForm.controls.password.errors?.something) {
              <mat-error i18n>Unbekannter Fehler beim Löschen</mat-error>
            }
          </mat-form-field>
        </form>
      }
    } @else {
      <mat-spinner></mat-spinner>
    }
  </ng-template>
  <ng-template #footer>
    <button
      mat-raised-button
      color="warn"
      [disabled]="confirmForm.disabled || confirmForm.invalid"
      [dtOverlayProgress]="confirmForm.disabled"
      (click)="delete()"
      i18n
      >Ja, Account löschen</button
    >
    <button mat-raised-button color="accent-less" [disabled]="confirmForm.disabled" (click)="close()" i18n>Nein, abbrechen</button>
  </ng-template>
</dt-modal-content>
